// SEARCH POPUP — guarded so optional search markup can never break mobile navigation.
const marriSearchWrapper = document.querySelector(".main_search_wrapper");
const marriSearchClose = document.querySelector(".main_search_close");
const marriSearchInnerEarly = document.querySelector(".main_search_inner");

document
  .querySelectorAll(".header_search.search_right, .header_search.search_left")
  .forEach(function (searchButton) {
    searchButton.addEventListener("click", function (e) {
      if (!marriSearchWrapper) return;
      e.preventDefault();
      marriSearchWrapper.classList.add("active");
      const inner = marriSearchWrapper.querySelector(".main_search_inner");
      const filters = document.querySelector("aside#main-collection-filters");
      const searchFilters = document.querySelector("aside#main-search-filters");
      if (filters) filters.style.zIndex = "2";
      if (searchFilters) searchFilters.style.zIndex = "2";
      if (typeof trapFocus === "function" && inner) trapFocus(marriSearchWrapper, inner);
    });
  });

if (marriSearchClose && marriSearchWrapper) {
  marriSearchClose.addEventListener("click", function () {
    marriSearchWrapper.classList.remove("active");
    const filters = document.querySelector("aside#main-collection-filters");
    const searchFilters = document.querySelector("aside#main-search-filters");
    setTimeout(() => {
      if (filters) filters.style.zIndex = "6";
      if (searchFilters) searchFilters.style.zIndex = "6";
    }, 500);
    if (typeof removeTrapFocus === "function") {
      removeTrapFocus(document.querySelector(".header_search.search_left"));
      removeTrapFocus(document.querySelector(".header_search.search_right"));
    }
  });
}

function closeOnEscape(event) {
  if (event.key !== "Escape" || !marriSearchWrapper) return;
  const filters = document.querySelector("aside#main-collection-filters");
  const searchFilters = document.querySelector("aside#main-search-filters");
  setTimeout(() => {
    if (filters) filters.style.zIndex = "6";
    if (searchFilters) searchFilters.style.zIndex = "6";
  }, 500);
  if (typeof removeTrapFocus === "function") {
    removeTrapFocus(document.querySelector(".header_search.search_left"));
    removeTrapFocus(document.querySelector(".header_search.search_right"));
  }
  marriSearchWrapper.classList.remove("active");
}

marriSearchWrapper?.addEventListener("keydown", closeOnEscape);
marriSearchWrapper?.addEventListener("click", function () { this.classList.remove("active"); });
marriSearchInnerEarly?.addEventListener("click", function (e) { e.stopPropagation(); });

const marriSearchInner = document.querySelector(".main_search_inner");
if (marriSearchInner) {
  marriSearchInner.addEventListener("mouseover", function (e) {
    const cursor = document.querySelector(".cursor");
    if (!cursor) return;
    cursor.style.transform = "translate(-50%,-50%)";
    cursor.style.scale = "0";
  });
  marriSearchInner.addEventListener("mouseleave", function (e) {
    const cursor = document.querySelector(".cursor");
    if (!cursor) return;
    cursor.style.left = e.clientX + "px";
    cursor.style.top = e.clientY + "px";
    cursor.style.transform = "translate(-50%,-50%)";
    cursor.style.scale = "1";
  });
}

// MOBILE DRAWER
// Marri Cortona uses the single authoritative controller rendered by mobile-drawer.liquid.
// Keeping the legacy handlers here caused duplicate click/focus listeners on mobile.

// SEARCH DRAWER ACCESSIBILITY

document.addEventListener("DOMContentLoaded", function () {
  const searchIcons = document.querySelectorAll(".header_search");
  const searchDrawer = document.querySelector(".main_search_wrapper");
  if (!searchDrawer || !searchIcons.length) return;

  const drawerInner = searchDrawer.querySelector(".main_search_inner");
  const focusableElements = searchDrawer.querySelectorAll("button, input, a");
  const closeButton = searchDrawer.querySelector(".main_search_close");
  if (!drawerInner || !closeButton) return;

  function disableSearchFocus() {
    focusableElements.forEach((el) => el.setAttribute("tabindex", "-1"));
  }

  function openSearchDrawer(event) {
    if (event.key === "Enter" || event.keyCode === 13) {
      event.preventDefault();
      searchDrawer.classList.add("active");
      searchDrawer.setAttribute("aria-hidden", "false");
      focusableElements.forEach((el) => el.setAttribute("tabindex", "0"));
      if (typeof trapFocus === "function") trapFocus(searchDrawer, drawerInner);
    }
  }

  function closeSearchDrawer() {
    searchDrawer.classList.remove("active");
    searchDrawer.setAttribute("aria-hidden", "true");
    disableSearchFocus();
    searchIcons[0]?.focus();
  }

  disableSearchFocus();
  searchIcons.forEach((icon) => icon.addEventListener("keydown", openSearchDrawer));
  closeButton.addEventListener("click", closeSearchDrawer);
  searchDrawer.addEventListener("keydown", function (event) {
    if (event.key === "Escape" || event.keyCode === 27) closeSearchDrawer();
  });
});

// MOBILE DRAWER ACCESSIBILITY
// Managed by the authoritative Marri mobile drawer controller.

const parents = document.querySelectorAll(".has_megamenu .parent_a");
const links = document.querySelectorAll(".mega_menu_link");
const images = document.querySelectorAll(".mega_menu_image a");
const dropdowns = document.querySelectorAll('.parent_main_link');
const childMain = document.querySelectorAll('.child_main_link');
const grandchildMain = document.querySelectorAll('.grandchild_main_link');

parents.forEach((parent) => {
  parent.addEventListener("focus", () => {
    parent
      .closest(".has_megamenu_inner")
      .nextElementSibling.classList.add("active");
  });

  parent.addEventListener("blur", () => {
    parent
      .closest(".has_megamenu_inner")
      .nextElementSibling.classList.remove("active");
  });
});

links.forEach((link) => {
  link.addEventListener("focus", () => {
    link.closest(".main_mega__menu_wrapper").classList.add("active");
  });

  link.addEventListener("blur", () => {
    link.closest(".main_mega__menu_wrapper").classList.remove("active");
  });
});

images.forEach((image) => {
  image.addEventListener("focus", () => {
    image.closest(".main_mega__menu_wrapper").classList.add("active");
  });

  image.addEventListener("blur", () => {
    image.closest(".main_mega__menu_wrapper").classList.remove("active");
  });
});

dropdowns.forEach((dropdown) => {
  dropdown.addEventListener('focus', () => {
    dropdown.nextElementSibling.classList.add('active');
  })
})

dropdowns.forEach((dropdown) => {
  dropdown.addEventListener('blur', () => {
    dropdown.nextElementSibling.classList.remove('active');
  })
})

childMain.forEach((cm) => {
  cm.addEventListener('focus', () => {
    cm.closest('.child_main').classList.add('active');
    const next = cm.nextElementSibling;
    if(next) {
      next.classList.add('active')      
    }
  })
})

childMain.forEach((cm) => {
  cm.addEventListener('blur', () => {
    cm.closest('.child_main').classList.remove('active');
    const next = cm.nextElementSibling;
    if(next) {
      next.classList.remove('active')        
    }
  })
})

grandchildMain.forEach((gm) => {
  gm.addEventListener('focus', () => {
    const gmcm = gm.closest('.child_main');
    const gmgm = gm.closest('.grandchild_main');
    gmgm.classList.add('active');
    gmcm.classList.add('active');
  })
})

grandchildMain.forEach((gm) => {
  gm.addEventListener('blur', () => {
    const gmcm = gm.closest('.child_main');
    const gmgm = gm.closest('.grandchild_main');
    gmgm.classList.remove('active');
    gmcm.classList.remove('active');
  })
})


